<script setup lang="ts">
const props = defineProps<{
  coverArea?: 'fixed';
  zIndex?: number;
  appendToBody?: boolean;
}>();

const showPopup = defineModel('showPopup');

const coverArea = ref(props.coverArea ? props.coverArea : 'absolute');
const zIndex = ref(props.zIndex ? props.zIndex : 199);

watch(
  () => showPopup.value,
  () => {
    if (showPopup.value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
);
</script>

<template>
  <Teleport v-if="props.appendToBody" to="body">
    <div class="popup-overlay" v-if="showPopup" @click="showPopup = false">
      <slot></slot>
    </div>
  </Teleport>
  <template v-else>
    <div class="popup-overlay" v-if="showPopup" @click="showPopup = false">
      <slot></slot>
    </div>
  </template>
</template>

<style scoped lang="scss">
.popup-overlay {
  position: v-bind(coverArea);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $mask-soft;
  z-index: v-bind(zIndex);
}
</style>
